import type { ReactNode } from "react";
import styles from "./Table.module.css";

interface TableProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function TableRoot({ children, className }: TableProps) {
  return (
    <div className={styles.wrapper}>
      <table className={`${styles.table} ${className ?? ""}`}>
        {children}
      </table>
    </div>
  );
}

interface TableSectionProps {
  readonly children?: ReactNode;
}

function TableHeader({ children }: TableSectionProps) {
  return <thead>{children}</thead>;
}

function TableBody({ children }: TableSectionProps) {
  return <tbody>{children}</tbody>;
}

interface TableRowProps {
  readonly children: ReactNode;
  readonly onClick?: () => void;
  readonly className?: string;
}

function TableRow({ children, onClick, className }: TableRowProps) {
  return (
    <tr
      onClick={onClick}
      className={`${onClick ? styles.clickable : ""} ${className ?? ""}`}
    >
      {children}
    </tr>
  );
}

interface TableCellProps {
  readonly children: ReactNode;
  readonly align?: "left" | "center" | "right";
  readonly className?: string;
}

function TableCell({ children, align = "left", className }: TableCellProps) {
  return (
    <td className={`${styles.cell} ${className ?? ""}`} style={{ textAlign: align }}>
      {children}
    </td>
  );
}

function TableHeaderCell({ children, align = "left", className }: TableCellProps) {
  return (
    <th className={`${styles.headerCell} ${className ?? ""}`} style={{ textAlign: align }}>
      {children}
    </th>
  );
}

export const Table = Object.assign(TableRoot, {
  Header: TableHeader,
  Body: TableBody,
  Row: TableRow,
  Cell: TableCell,
  HeaderCell: TableHeaderCell,
});
